import note from '../content/reportSecurityNote.json';

export const appendSecuritySlide = (pptx) => {
  const slide = pptx.addSlide();
  slide.background = { color: 'FFFFFF' };
  slide.addText(note.title, { x: 0.5, y: 0.45, w: '90%', h: 0.6, fontSize: 22, bold: true, color: '153E35' });
  slide.addText(note.measures.join('\n\n'), { x: 0.5, y: 1.2, w: '90%', h: 2.3, fontSize: 16, color: '273D35', valign: 'top', fit: 'shrink' });
  slide.addText(`${note.platform_attribution} ${note.platform_statement}`, { x: 0.5, y: 3.55, w: '90%', h: 0.65, fontSize: 13, color: '273D35', fit: 'shrink' });
  slide.addText(note.advice, { x: 0.5, y: 4.3, w: '90%', h: 0.3, fontSize: 11, color: '273D35', fit: 'shrink' });
  slide.addText(note.disclaimer, { x: 0.5, y: 4.8, w: '90%', h: 0.5, fontSize: 9, color: '52645E', fit: 'shrink' });
};